// extracted by mini-css-extract-plugin
module.exports = {"displayArea":"SearchResults_displayArea__3pNL0","cardArea":"SearchResults_cardArea__3Aie1"};